import { render } from "./PreSale.vue?vue&type=template&id=ddd733ec"
import script from "./PreSale.vue?vue&type=script&lang=js"
export * from "./PreSale.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__